exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7ba5bd90]:export{menuText:#bfcbd9;menuActiveText:#409eff;subMenuActiveText:#f4f4f5;menuBg:#304156;menuHover:#263445;subMenuBg:#1f2d3d;subMenuHover:#001528;sideBarWidth:205px}.ai-btn[data-v-7ba5bd90]{width:67px;height:85px;position:fixed;right:20px;bottom:20px;cursor:pointer;z-index:200}.ai-btn img[data-v-7ba5bd90]{width:100%;height:100%;-webkit-user-drag:none}", ""]);

// exports
